import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  href?: string;
}

interface BreadcrumbsProps {
  items: Crumb[];
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav aria-label="面包屑导航" className="mb-5">
      <ol className="flex flex-wrap items-center gap-1.5 font-label text-xs text-foreground-500">
        <li>
          <Link to="/" className="inline-flex items-center gap-1 transition-colors hover:text-primary-700">
            <i className="ri-home-5-line" aria-hidden="true"></i>
            首页
          </Link>
        </li>
        {items.map((item) => (
          <li key={item.label} className="flex items-center gap-1.5">
            <i className="ri-arrow-right-s-line text-foreground-300" aria-hidden="true"></i>
            {item.href ? (
              <Link to={item.href} className="transition-colors hover:text-primary-700">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}